import { createAction } from 'redux-actions';
import {
  EXPORT_WATCH_LIST_ENTRIES_CSV,
  CLEAR_EXPORT_WATCH_LIST_ENTRIES_CSV,
} from '../types';

import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  exportWatchListEntriesCsv,
  exportWatchListEntriesCsvPending,
  exportWatchListEntriesCsvFulfilled,
  exportWatchListEntriesCsvRejected,
} = createAsyncActions(EXPORT_WATCH_LIST_ENTRIES_CSV, 'exportWatchListEntriesCsv');

export const clearWatchListEntriesCsv = createAction(CLEAR_EXPORT_WATCH_LIST_ENTRIES_CSV);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/exportWatchListEntriesCsvAction.js